var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93935 13.1464L7.69211 12.3973L7.69211 12.3973L7.6921 12.3973C5.3389 11.6129 4.16229 11.2207 4.16229 10.5C4.16229 9.77921 5.3389 9.38701 7.69212 8.60261L16.2053 5.76488C17.8611 5.21295 18.689 4.93699 19.126 5.37401C19.563 5.81102 19.287 6.63892 18.7351 8.29471L15.8974 16.8079L15.8974 16.8079L15.8974 16.8079C15.113 19.1611 14.7208 20.3377 14 20.3377C13.2793 20.3377 12.8871 19.1611 12.1026 16.8079L11.3536 14.5606L15.7071 10.2071C16.0976 9.81656 16.0976 9.18339 15.7071 8.79287C15.3166 8.40234 14.6834 8.40234 14.2929 8.79287L9.93935 13.1464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFill);
export default __webpack_public_path__ + "static/media/Send_fill.c55cd40b69d8d7a8a3a5e7a7eed0021c.svg";
export { ForwardRef as ReactComponent };